export const hasMetaErrors = (meta: unknown): meta is Readonly<{ errors: readonly unknown[] }> =>
  typeof meta === 'object' &&
  meta !== null &&
  'errors' in meta &&
  Array.isArray(meta.errors) &&
  meta.errors.length > 0
